import HttpClient from "../infra/HttpClient";

export default class DashboardService {

	constructor(readonly httpClient: HttpClient, readonly baseUrl: string) {
	}

	async getUsage(month?: string): Promise<any> {
		const query = month ? `?month=${encodeURIComponent(month)}` : "";
		return this.httpClient.get(`${this.baseUrl}/dashboard/usage${query}`);
	}

	async consolidateDay(date: string): Promise<any> {
		return this.httpClient.put(`${this.baseUrl}/dashboard/usage/days/${encodeURIComponent(date)}`, {});
	}
}
